import React from 'react';
import { Container } from 'react-bootstrap';

export const HubContainer: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => (
  <Container fluid className="px-4 pb-6 overflow-auto">
    {children}
  </Container>
);
